import "../Dashboard/dashboard.css"
import "../Projects/project.css"
import React, { useEffect, useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import { Link } from 'react-router-dom';
import { getDealsAssigned, updateTcStatus, showToast, MarkAsClosed, MarkAsCompleted, RetryProjectCommissionCharge } from "../Utils/utils";
import ReactPaginate from 'react-paginate';
import { Row, Col } from "react-bootstrap";
import Loaderspinner from "../../components/Loader";
import ConfirmationModal from "../../components/Modal/ConfirmationModal";
import CommissionBadge from "../../components/CommissionBadge";

const DealsAssigned = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [assignedList, setAssignedList] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false);
    const [showCompleteConfirm, setShowCompleteConfirm] = useState(false);
    const [showRetryChargeConfirm, setShowRetryChargeConfirm] = useState(false);
    const [projectId, setProjectId] = useState('');
    const [closedAtInput, setClosedAtInput] = useState('');
    const [closeType, setCloseType] = useState('standard');
    const [completedAtInput, setCompletedAtInput] = useState('');

    const getCurrentDateTimeLocal = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    };

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        try {
            setLoading(true)
            const limit = 10;
            const offset = page * limit;

            const response = await getDealsAssigned({
                search,
                limit,
                offset,
            });
            setAssignedList(response?.data || []);
            if ((response?.data?.length || 0) < limit) {
                setTotalPages(page + 1);
            } else {
                setTotalPages(page + 2);
            }
        } catch (error) {
            console.error("Error fetching asignee list:", error);
        } finally {
            setLoading(false)
        }
    };

    const handleUpdateStatus = async (id, value) => {
        try {
            setLoading(true)
            const response = await updateTcStatus({ id, value });
            if (response.status == 200) {
                showToast("Status updated successfully", "success");
                fetchList()
            } else {
                showToast("Unable to update status", "error");
            }
        } catch (error) {
            console.error("Error updating status:", error);
        } finally {
            setLoading(false)
        }
    }

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const MarkClosed = async (id) => {
        if (!closedAtInput) {
            showToast("Please select a closed date & time", "error");
            return;
        }
        try {
            setLoading(true);
            setShow(false);
            const response = await MarkAsClosed(id, closedAtInput, closeType === 'hard_money');
            showToast(response?.message, "success")
            fetchList()
        } catch (error) {
            showToast(error?.message, "error")
            console.error("Error fetching lenders:", error);
        } finally {
            setLoading(false)
        }
    };

    const RetryChargeCommission = async (id) => {
        try {
            setLoading(true);
            setShowRetryChargeConfirm(false);
            const response = await RetryProjectCommissionCharge(id);
            if (response?.data?.commission_status === 'charged') {
                showToast("Commission charged successfully", "success")
            } else {
                showToast("Charge failed again — the borrower has been notified to update their card", "error")
            }
            fetchList()
        } catch (error) {
            showToast(error?.message, "error")
            console.error("Error retrying commission charge:", error);
        } finally {
            setLoading(false)
        }
    };

    const MarkCompleted = async (id) => {
        if (!completedAtInput) {
            showToast("Please select a completed date & time", "error");
            return;
        }
        try {
            setLoading(true);
            setShowCompleteConfirm(false);
            const response = await MarkAsCompleted(id, completedAtInput);
            showToast(response?.message, "success")
            fetchList()
        } catch (error) {
            showToast(error?.message, "error")
            console.error("Error fetching lenders:", error);
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div className="g-sidenav-show bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div className="header header-bg-lender pt-3">
                            <div className="col-lg-6 col-7">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4" style={{ marginLeft: '30px' }}>
                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                                        <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>Deals Assigned</span></li>
                                    </ol>
                                </nav>
                            </div>

                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Deals Assigned</h5>
                                                    {/* <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all projects created by borrowers. Use this report to review project details, check status, and ensure projects comply with platform guidelines."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} /> */}
                                                </div>
                                                <div>
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Project Name</th>
                                                        <th>Borrwer</th>
                                                        <th>Borrower's Phone number</th>
                                                        <th>Lender</th>
                                                        <th>Lender's Phone number</th>
                                                        <th>Commission</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {assignedList?.length > 0 ? (
                                                        assignedList.map((project, index) => (
                                                            <tr key={index}>
                                                                <td className="table-user">
                                                                    <div>
                                                                        <span>{project.project_name}</span>
                                                                    </div>
                                                                </td>

                                                                <td className="table-user">
                                                                    <div style={{ width: "120px" }}><span>{`${project?.user?.about.name} ${project?.user?.about.lastname}`}</span></div>
                                                                </td>

                                                                <td className="table-user">
                                                                    {project?.user?.phone}
                                                                </td>

                                                                <td className="table-user">
                                                                    {`${project?.funder?.about.name} ${project?.funder?.about.lastname}`}
                                                                </td>
                                                                <td>
                                                                    {project?.funder?.phone}
                                                                </td>
                                                                <td>
                                                                    <div style={{ width: "150px" }}>
                                                                        <CommissionBadge status={project?.commission_status} amount={project?.commission_amount} required={project?.commission_required} />
                                                                        {project?.closed_at != null && project?.commission_required !== false && project?.commission_status === 'failed' &&
                                                                            <button className="commission-retry-btn" onClick={() => {
                                                                                setShowRetryChargeConfirm(true)
                                                                                setProjectId(project?.id)
                                                                            }}>
                                                                                Charge again
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {project?.assigned_tc_status == "pending" ?
                                                                        <>
                                                                            <div style={{ width: "150px" }}>
                                                                                <button className="viewproject-btn pull-right mb-1" onClick={() => handleUpdateStatus(project.id, "accepted")}>
                                                                                    <span className="text-white">Accepted Tactical TC</span>
                                                                                </button>
                                                                            </div>
                                                                            <div style={{ width: "150px" }}>
                                                                                <button className="viewproject-btn pull-right mb-1" onClick={() => handleUpdateStatus(project.id, "rejected")}>
                                                                                    <span className="text-white">Rejected Tactical TC</span>
                                                                                </button>
                                                                            </div>
                                                                        </> :
                                                                        <div className="viewproject-btn pull-right mb-1" style={{ background: project.assigned_tc_status == "accepted" ? "#00c04b" : "#FF0000", width: "fit-content" }}>
                                                                            {project.assigned_tc_status[0].toUpperCase() + project.assigned_tc_status.slice(1)}
                                                                        </div>
                                                                    }
                                                                    {project?.closed_at == null ?
                                                                        <button className="viewproject-btn-2 pull-right" style={{ width: "fit-content" }} onClick={() => {
                                                                            setClosedAtInput(getCurrentDateTimeLocal())
                                                                            setCloseType('standard')
                                                                            setShow(true)
                                                                            setProjectId(project?.id)
                                                                        }}>
                                                                            <span className="text-white"
                                                                            >Mark as Closed</span>
                                                                        </button>
                                                                        : project?.completed_at == null ?
                                                                            <>
                                                                                <div className="viewproject-btn pull-right mb-1" style={{ width: "fit-content" }}>
                                                                                    <span className="text-white">Closed</span>
                                                                                </div>
                                                                                <button className="viewproject-btn-2 pull-right" style={{ width: "fit-content" }} onClick={() => {
                                                                                    setCompletedAtInput(getCurrentDateTimeLocal())
                                                                                    setShowCompleteConfirm(true)
                                                                                    setProjectId(project?.id)
                                                                                }}>
                                                                                    <span className="text-white"
                                                                                    >Mark as Completed</span>
                                                                                </button>
                                                                            </>
                                                                            :
                                                                            <button className="viewproject-btn pull-right" style={{ width: "fit-content" }}>
                                                                                <span className="text-white">Completed</span>
                                                                            </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))) :
                                                        < tr >
                                                            <td colSpan="11" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                </div >
            </div >
            <ConfirmationModal
                show={show}
                onClose={() => setShow(false)}
                onConfirm={() => MarkClosed(projectId)}
                title="Mark as Closed"
                body={
                    <>
                        <p>Are you sure you want to mark this project as closed, which means the borrower has recieved the loan amount from lender</p>
                        <label htmlFor="closed-at-input" className="form-label">Closed date &amp; time</label>
                        <input
                            id="closed-at-input"
                            type="datetime-local"
                            className="form-control"
                            value={closedAtInput}
                            onChange={(e) => setClosedAtInput(e.target.value)}
                        />
                        <div className="mt-3">
                            <div className="form-check">
                                <input
                                    id="close-type-standard"
                                    type="radio"
                                    name="close-type"
                                    className="form-check-input"
                                    checked={closeType === 'standard'}
                                    onChange={() => setCloseType('standard')}
                                />
                                <label htmlFor="close-type-standard" className="form-check-label">Standard close</label>
                            </div>
                            <div className="form-check">
                                <input
                                    id="close-type-hard-money"
                                    type="radio"
                                    name="close-type"
                                    className="form-check-input"
                                    checked={closeType === 'hard_money'}
                                    onChange={() => setCloseType('hard_money')}
                                />
                                <label htmlFor="close-type-hard-money" className="form-check-label">Hard money lender (commission waived, borrower is not charged)</label>
                            </div>
                        </div>
                    </>
                }
            />
            <ConfirmationModal
                show={showCompleteConfirm}
                onClose={() => setShowCompleteConfirm(false)}
                onConfirm={() => MarkCompleted(projectId)}
                title="Mark as Completed"
                body={
                    <>
                        <p>Are you sure you want to mark this project as completed, which means the lender has been paid back for the project or the deal terms are completed.</p>
                        <label htmlFor="completed-at-input" className="form-label">Completed date &amp; time</label>
                        <input
                            id="completed-at-input"
                            type="datetime-local"
                            className="form-control"
                            value={completedAtInput}
                            onChange={(e) => setCompletedAtInput(e.target.value)}
                        />
                    </>
                }
            />
            <ConfirmationModal
                show={showRetryChargeConfirm}
                onClose={() => setShowRetryChargeConfirm(false)}
                onConfirm={() => RetryChargeCommission(projectId)}
                title="Charge Commission Again"
                body={
                    <p>Are you sure you want to retry charging the borrower's commission for this project? Make sure the borrower has updated their payment method before retrying.</p>
                }
            />
        </>

    );
};

export default DealsAssigned;
